// extracted by mini-css-extract-plugin
export default {"illustration_image":"AddMediaModal_illustration_image__s3A4j"};